export default {
  lastServiceWorkerUpdate(state) {
    if (!state.lastServiceWorkerUpdate) {
      return new Date(0)
    }
    return new Date(state.lastServiceWorkerUpdate)
  },
}
